import { combineReducers } from 'redux'
import siteMenuReducer from './siteMenu'
import locationReducer from './location'
import contentReducer from './content'
import officeLocationReducer from './officeLocation'
import selectedServiceReducer from './selectedService'
import listedServicesReducer from './listedServices'
import blockUIReducer from './blockUI'
// import { routerStateReducer } from 'redux-router'

export const makeRootReducer = (asyncReducers) => {
  return combineReducers({
    siteMenuVisible: siteMenuReducer,
    content: contentReducer,
    location: locationReducer,
    selectedLocation: officeLocationReducer,
    selectedService: selectedServiceReducer,
    listedServices: listedServicesReducer,
    blockUI: blockUIReducer,
    ...asyncReducers
  })
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js